import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import './css/icons.css'
import { Settings } from 'luxon'
import LuxonUtils from '@date-io/luxon'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'

Settings.defaultLocale = 'pt-br'

ReactDOM.createRoot(document.getElementById('root')).render(
  <MuiPickersUtilsProvider utils={LuxonUtils} locale={Settings.defaultLocale}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </MuiPickersUtilsProvider>,
)

reportWebVitals()
